// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface EasypostConfigOut {}

export const EasypostConfigOutSerializer = {
  _fromJsonObject(_object: any): EasypostConfigOut {
    return {};
  },

  _toJsonObject(_self: EasypostConfigOut): any {
    return {};
  },
};
